// extracted by mini-css-extract-plugin
export default {"app":"App_app__zr1wm","container":"App_container__Rt8T2","resultsSection":"App_resultsSection__k0mtS","tabsNav":"App_tabsNav__5jSAE","tabContent":"App_tabContent__jGtJ0"};